export default "__VITE_ASSET__DHgz_wlH__"